// components/SummaryCardGrid.jsx
import React from "react";

const SummaryCardGrid = ({ cards = [] }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {cards.map((item, index) => (
        <div
          key={index}
          className="bg-dry border border-border p-4 rounded shadow text-center"
        >
          <h2 className={`text-3xl font-bold ${item.color}`}>{item.count}</h2>
          <p className="text-sm font-medium text-text">{item.title}</p>
          <p className="text-xs text-textGray mt-1">{item.sub}</p>
        </div>
      ))}
    </div>
  );
};

export default SummaryCardGrid;
